import {
  AllPodcastsSocialStatsResponse,
  PodcastSocialStatsResponse,
  SocialShareStatsResponse,
} from 'api';
import { aggregateStats } from './utils';

export function socialVideoInfoSelector(d: SocialShareStatsResponse) {
  return d.data.map((video) => ({
    platform: video.platform,
    sharePostId: video.socialShareId,
    sharePostUrl: video.sharePostUrl,
    sharePostTitle: video.sharePostTitle,
    createdAtMillis: video.createdAtMillis,
    statistics: { ...video.statistics },
    previewThumbnailImageUrl: video.embedVideo.previewThumbnailImageUrl,
    projectName: video.embedVideo.project?.projectConfig?.projectName,
  }));
}

export function sortDescSocialVideoInfoSelector(d: SocialShareStatsResponse) {
  const socialData = socialVideoInfoSelector(d);
  return socialData.sort((a, b) => b.createdAtMillis - a.createdAtMillis);
}

export function socialStatsSummarySelector(d: SocialShareStatsResponse) {
  const summaryStats = d.data.filter((stat) => stat.platform !== 'youtube');
  const youtubeStats = d.data.filter((stat) => stat.platform === 'youtube');

  return [aggregateStats(summaryStats), aggregateStats(youtubeStats)];
}

export function hasSocialShareStatsSelector(d: SocialShareStatsResponse) {
  return d.data.length > 0;
}

export function allPodcastsSocialInfoSelector(
  d: AllPodcastsSocialStatsResponse,
) {
  return d.podcasts.map((podcast) => ({
    podcastId: podcast.podcastId,
    title: podcast.title ?? 'unknown',
    thumbnailUrl: podcast.thumbnailUrl ?? '',
    totalEpisodes: podcast.totalEpisodes,
    statistics: { ...podcast.statistics },
  }));
}

export function podcastSocialShareStatsDetailsSelector(
  d: PodcastSocialStatsResponse,
) {
  return d.episodes.map((episode) => ({
    episodeId: episode.episodeId,
    episodeTitle: episode.title ?? 'unknown',
    thumbnailUrl: episode.thumbnailUrl ?? '',
    statistics: episode.statistics,
  }));
}

export function podcastSocialStatsSummarySelector(
  d: PodcastSocialStatsResponse,
) {
  return aggregateStats(d.episodes);
}

export function hasAllPodcastsStatsSelector(d: AllPodcastsSocialStatsResponse) {
  if (!d) {
    return undefined;
  }
  return d.podcasts.length > 0;
}

export function allPodcastsStatsSummarySelector(
  d: AllPodcastsSocialStatsResponse,
) {
  return aggregateStats(d.podcasts);
}

export function podcastTitleSelector(
  d: AllPodcastsSocialStatsResponse,
  podcastId?: string,
) {
  if (!podcastId) {
    return undefined;
  }
  return d.podcasts?.find((podcast) => podcast.podcastId === podcastId)?.title;
}

export function episodeTitleSelector(
  d: PodcastSocialStatsResponse,
  episodeId?: string,
) {
  if (!episodeId) {
    return undefined;
  }
  return (
    d.episodes?.find((episode) => episode.episodeId === episodeId)?.title ??
    'unknown'
  );
}
